// extracted by mini-css-extract-plugin
export var button = "_9y-0";
export var icon = "_9y-1";